module.exports = __webpack_public_path__ + "static/media/icon.16bee646.svg";